export var ChargesForDamagedMissingItemsIA = function ChargesForDamagedMissingItemsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "nIK7TZ",
        defaultMessage: [{
          "type": 0,
          "value": "Frais pour articles manquants ou endommagés"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "5P7k5e",
        defaultMessage: [{
          "type": 0,
          "value": "Pour les commandes passées avec le paiement à 60 jours, tous les articles signalés seront supprimés de votre facture d'origine. Pour les commandes qui ont été facturées à l'expédition, nous rembourserons le montant des articles signalés sur la carte de paiement enregistrée."
        }]
      }), strictLocalize({
        id: "g05TNU",
        defaultMessage: [{
          "type": 0,
          "value": "Si vous choisissez d'échanger des articles, une nouvelle commande sera créée. Les articles de remplacement vous seront facturés séparément à la date d'échéance de votre nouvelle facture, une fois la commande expédiée."
        }]
      }), strictLocalize({
        id: "2RyUSl",
        defaultMessage: [{
          "type": 0,
          "value": "Si vous avez d'autres questions, contactez-nous."
        }]
      })];
    }
  };
};